import React from "react";
import ReactJson from "react-json-view";

import {
  ColorDisabled,
  ColorError,
  ColorSuccess,
  IgDivider,
  IgTypography,
} from "@intelligems/ig-theme";
import { CartTransformType } from "@intelligems/ig-types";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
} from "@mui/material";

import { useGetExperiencesList } from "../../../api/experiences-list/get-experiences-list";
import theme from "../../../theme";

interface ExperienceIdsSectionProps {
  experiences:
    | CartTransformType["experiences"]
    | CartTransformType["experiments"];
}

const ExperimentIdsSection = ({ experiences }: ExperienceIdsSectionProps) => {
  const experienceList = useGetExperiencesList({ category: "experiment" });

  if (!experienceList.data) return null;

  return (
    <>
      <IgTypography variant={"body1"} sx={{ fontWeight: 600 }}>
        Experiment Metadata:
      </IgTypography>
      <br />
      <IgTypography
        sx={{
          color:
            experiences && experiences.length
              ? ColorSuccess.main
              : ColorError.main,
          marginLeft: "20px",
        }}
      >
        {experiences && experiences.length
          ? `Experiences linked to Cart Transform: ${experiences
              .map(
                (e) =>
                  experienceList.data.experiencesList.find(
                    (el) => el.id === e.id
                  )?.name
              )
              .join(", ")}`
          : "No experiences linked to Cart Transform"}
      </IgTypography>
      <br />
      {experiences && experiences.length ? (
        <Grid item sx={{ marginLeft: "20px" }}>
          <ReactJson
            name={"experiments"}
            theme={"shapeshifter:inverted"}
            shouldCollapse={false}
            src={experiences[0]}
            sortKeys={true}
          />
        </Grid>
      ) : null}
      {/*{experiences.map((experiment) => (*/}
      {/*  <Grid item key={experiment.id} sx={{ marginLeft: "40px" }}>*/}
      {/*    <IgCopyTextTypography text={experiment.id} />*/}
      {/*    <br />*/}
      {/*    <IgTypography sx={{ marginLeft: "20px", fontWeight: 600 }}>*/}
      {/*      Test Group Ids:*/}
      {/*    </IgTypography>*/}
      {/*    <br />*/}
      {/*    {experiment.testGroupIds.map((id) => (*/}
      {/*      <>*/}
      {/*        <IgCopyTextTypography*/}
      {/*          key={id}*/}
      {/*          typographyProps={{ sx: { marginLeft: "40px" } }}*/}
      {/*          text={id}*/}
      {/*        />*/}
      {/*        <br />*/}
      {/*      </>*/}
      {/*    ))}*/}
      {/*  </Grid>*/}
      {/*))}*/}
    </>
  );
};

interface CartTransformAccordionProps {
  cartTransform: CartTransformType;
  index: number;
  totalCount: number;
}

export const CartTransformAccordion = ({
  cartTransform,
  index,
  totalCount,
}: CartTransformAccordionProps) => {
  return (
    <Grid item sx={{ width: "100%" }}>
      <Accordion
        elevation={0}
        disableGutters
        sx={{
          width: "100%",
          border: `solid 1px ${ColorDisabled.main}`,
          "&.MuiAccordion-root": {
            borderRadius: "10px",
          },
        }}
      >
        <AccordionSummary
          expandIcon={
            <ExpandMoreIcon sx={{ color: theme.palette.disabled.main }} />
          }
          aria-controls={cartTransform.id}
          id={`${cartTransform.id}`}
        >
          <Grid item>
            <IgTypography igStyle={"semibold"} sx={{ fontSize: "18px" }}>
              Cart Transform {totalCount > 1 ? ` ${index + 1}` : ""}
            </IgTypography>
          </Grid>
        </AccordionSummary>
        <IgDivider />
        <AccordionDetails sx={{ paddingBottom: "10px" }}>
          <IgTypography sx={{ fontWeight: 600 }}>Details:</IgTypography>
          <br />
          <IgTypography
            sx={{
              marginLeft: "20px",
              color: cartTransform.isPricingFunctionId
                ? ColorSuccess.main
                : ColorError.main,
            }}
          >
            {cartTransform.isPricingFunctionId
              ? "Correctly linked to Intelligems Pricing Function"
              : "Not linked to Intelligems Pricing Function"}
          </IgTypography>
          <br />
          <IgTypography>
            <IgTypography sx={{ fontWeight: 600 }}>Mode: </IgTypography>{" "}
            {cartTransform.cartTransformMode || "NOT SET"}
          </IgTypography>
          <br />
          <ExperimentIdsSection
            experiences={
              cartTransform.experiences || cartTransform.experiments || []
            }
          />
        </AccordionDetails>
      </Accordion>
    </Grid>
  );
};
